import React from 'react';

export const MatchEventsModuleStageTime = ({row, isLast, isPenalties}) => {
  const {isCritical, addedTime, gameTimeDisplay} = row;

  return (
    <React.Fragment>
      {
        isPenalties && !isLast ? <div className={'match-event-module-stages-time-line'}/> : null
      }
      <div className={['match-event-module-stages-time-container', isCritical ? 'match-event-module-stages-critical-time-container': ''].join(' ')}>
        {
          isPenalties ? <div className={'match-event-module-stages-time-yellow-circle-penalty'}>{`${gameTimeDisplay}P`}</div> : null
        }
        {
          !isPenalties && !addedTime && gameTimeDisplay
        }
        {
          !isPenalties && !!addedTime ? <div className={'match-event-module-stages-critical-time-extra-time'}>{`${gameTimeDisplay}`}</div> : null
        }
      </div>
    </React.Fragment>
  )
};